(function (Drupal, drupalSettings) {
  Drupal.behaviors.responsives = {
    attach: function (context, settings) {
      const body = context.querySelector("body");
      if (body && !body.dataset.responsiveProcessed) {
        body.dataset.responsiveProcessed = "true";

        if (window.innerWidth < 990) {
          const lieuxList = context.querySelector(".lieux-list");
          if (lieuxList) {
            lieuxList.style.display = "none";

            const selectWrapper = document.createElement("div");
            selectWrapper.className =
              "js-form-item form-item js-form-type-select";

            const selectElement = document.createElement("select");
            selectElement.className = "form-select lieux-list-select";

            const emptyOption = document.createElement("option");
            emptyOption.className = "empty";
            emptyOption.textContent = "Sélectionner un hôpital";
            selectElement.appendChild(emptyOption);

            lieuxList.before(selectWrapper);
            selectWrapper.appendChild(selectElement);

            const listItems = lieuxList.querySelectorAll("li");
            listItems.forEach((listItem) => {
              const link = listItem.querySelector("a");
              if (link) {
                const textLink = link.innerHTML
                  .replace("</span>", " ")
                  .replace("<span>", "");
                const dataItem = link.getAttribute("data-item");

                const option = document.createElement("option");
                option.value = dataItem;
                option.textContent = textLink;

                selectElement.appendChild(option);
              }
            });

            selectElement.addEventListener("change", function () {
              document
                .querySelectorAll(".lieux-item, .service")
                .forEach((item) => {
                  item.classList.remove("active");
                });

              const toOpen = this.value;
              const targetItems = document.querySelectorAll(
                `#${toOpen}, div[data-item='${toOpen}']`
              );
              targetItems.forEach((item) => {
                item.classList.add("active");
              });
            });
          }
        }
      }
    },
  };
})(Drupal, drupalSettings);
